import { useCallback } from 'react';
import { useRegisterContext } from '../reducer/useRegister';

export const useResetRegisterState = () => {
  const [state, dispatch] = useRegisterContext();
  const data = state.data;
  return useCallback(
    (step: 'HEALTH_AUTH' | 'REQUESTING_REGISTRATION_CODE') => {
      if (
        data.type === 'REQUESTING_REGISTRATION_CODE' &&
        step === 'HEALTH_AUTH'
      ) {
        dispatch({
          type: 'HEALTH_AUTH',
          phoneNumber: data.phoneNumber,
        });
      } else if (
        data.type === 'CREATE_ACCOUNT' &&
        step === 'REQUESTING_REGISTRATION_CODE'
      ) {
        dispatch({
          type: 'REQUESTING_REGISTRATION_CODE',
          phoneNumber: data.phoneNumber,
          zipCode: data.zipCode,
        });
      }
    },
    [data, dispatch],
  );
};
